import { IconBox, IconProps } from '../IconBox';

type EyeIconProps = IconProps & {
  crossed?: boolean;
};

const EyeIcon = ({ crossed = false, ...props }: EyeIconProps) => (
  <IconBox {...props} viewBox="0 0 30 30" fill="none">
    <path
      fill="currentColor"
      d="M15 4.007812C8.402344 4.007812 2.769531 8.074219 0.488281 13.808594C2.769531 19.542969 8.402344 23.605469 15 23.605469C21.597656 23.605469 27.230469 19.542969 29.511719 13.808594C27.230469 8.074219 21.601562 4.007812 15 4.007812ZM15 20.339844C11.359375 20.339844 8.402344 17.414062 8.402344 13.808594C8.402344 10.203125 11.359375 7.277344 15 7.277344C18.640625 7.277344 21.597656 10.203125 21.597656 13.808594C21.597656 17.414062 18.640625 20.339844 15 20.339844ZM15 9.886719C12.816406 9.886719 11.042969 11.644531 11.042969 13.808594C11.042969 15.96875 12.816406 17.726562 15 17.726562C17.183594 17.726562 18.957031 15.96875 18.957031 13.808594C18.957031 11.644531 17.183594 9.886719 15 9.886719Z"
    />
    {crossed && (
      <path
        d="M6 24L24 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    )}
  </IconBox>
);

export default EyeIcon;
